BookingApp.controller('BusSeatDetailController',['$scope','$uibModalInstance',function($scope,$uibModalInstance){
    $("#temp-backdrop").remove();
	$scope.seats = $scope.$resolve.data.SeatLayout.seats;
	$scope.BoardingPoints = $scope.$resolve.data.RouteDetail.BoardingPoints;
	$scope.DroppingPoints = $scope.$resolve.data.RouteDetail.DroppingPoints;
	$scope.selectedSeats = [];
	$scope.TotalPrice = 0;

    $scope.SelectedPoints = {
        BordingPoint : undefined,
    	DroppingPoint : undefined
	}

	$scope.addOrRemoveSeat = function(seat){
        console.log(seat);
		 if(!$scope.seats[seat].isSelected){
			 $scope.selectedSeats.push($scope.seats[seat]);
			 $scope.seats[seat].isSelected = true;
			 $scope.seats[seat].SeatImgSrc = ($scope.seats[seat].SeatType == "sleeper") ? "img/bus-sleeper-selected.png" : "img/bus-seat-selected.png";
			 $scope.UpdateTotalPrice(parseInt($scope.seats[seat].SeatFare));
		 }else{

			 for (var i = $scope.selectedSeats.length - 1; i >= 0; i--) {
				 if ($scope.selectedSeats[i].SeatName == $scope.seats[seat].SeatName) {
					 $scope.selectedSeats.splice(i, 1);
					 break;
				 }
			 }

			 $scope.seats[seat].isSelected = false;
			 $scope.seats[seat].SeatImgSrc = ($scope.seats[seat].SeatType == "sleeper") ? "img/bus-sleeper-available.png" : "img/bus-seat-available.png";
			 $scope.UpdateTotalPrice((0 - parseInt($scope.seats[seat].SeatFare)));
		 }
	 }


	 $scope.UpdateTotalPrice = function(price){
	 	$scope.TotalPrice  = $scope.TotalPrice + price;
	 }

    $scope.cancel = function () {
        $uibModalInstance.dismiss();
    }

    $scope.proceed = function () {
	 	$uibModalInstance.close({
            type:$scope.$resolve.type,
			busData:{
            	RouteId:$scope.$resolve.data.RouteDetail.RouteId,
                TotalPrice:$scope.TotalPrice,
                seats:$scope.selectedSeats,
                BordingPoint:$scope.SelectedPoints.BordingPoint,
                DroppingPoint:$scope.SelectedPoints.DroppingPoint,
                TravelName:$scope.$resolve.data.RouteDetail.TravelName,
                ArrivalTime:$scope.$resolve.data.RouteDetail.ArrivalTime,
                DepartureTime:$scope.$resolve.data.RouteDetail.DepartureTime,
			}
		});
    };
	
}]);